import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import { PROFILE_NOTIFICATION } from 'apps/auth/constants/formName';
import media from 'apps/auth/theme/media';

import SwitchInputNotification from './SwitchInputNotification';

const SwitchInputWrapper = styled.div`
    border-top: 1px solid ${(props) => props.theme.grey_28_tr};
    padding: 20px 24px 0 24px;
    margin: 0 -24px;

    ${media.tablet720} {
        margin: 0 -32px;
        padding: 48px 32px 0 32px;
    }
`;

const ProfileNotificationsPopup = (props) => {
    useEffect(() => {
        return props.onSetIsShowSuccessStatus();
    }, []);

    return (
        <ComplexPopup withoutButton textCenter popupRef={props.popupRef}>
            <ComplexPopupRow>{props.title}</ComplexPopupRow>
            <SwitchInputWrapper>
                <SwitchInputNotification field={props.fields.subscribeMarketingEmail} popupRef={props.popupRef} />
                {/*<SwitchInputNotification field={props.fields.subscribeMarketingSms} />*/}
                {/*<SwitchInputNotification field={props.fields.subscribeMarketingPush} />*/}
            </SwitchInputWrapper>
        </ComplexPopup>
    );
};
const mapStateToProps = (state) => {
    return {
        fields: state.form[PROFILE_NOTIFICATION].fields,
    };
};
export default connect(mapStateToProps)(ProfileNotificationsPopup);
